module.exports = __webpack_public_path__ + "img/3_92.dc271110.png";